import { animateScroll as scroll } from 'react-scroll';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { getLogger } from '../../util/logger';
import bureaucrat from '../../util/Bureaucrat';
import { parseErrorMessage } from '../util/dataHelpers';

const logger = getLogger('RequestTrialForm');

const trialErrors = {
  100: {
    title: 'Trial Unavailable',
    message: 'The tenant already has existing licenses.',
  },
  101: {
    title: 'Trial Unavailable',
    message: 'The tenant is in an embargoed country.',
  },
  102: {
    title: 'Trial Pending',
    message:
      "The tenant's host country is under a compliance hold. A Poly representative will contact you shortly.",
  },
};

export const useRequestTrialFromHandlers = (onComplete, onCancel) => {
  const history = useHistory();
  const [showProgress, setShowProgress] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlert] = useState({});

  const handleCancel = (event) => {
    event.preventDefault();
    onCancel();
  };

  const handleSubmit = async (values, actions) => {
    scroll.scrollToTop();
    logger.debug(values);
    setShowProgress(true);
    try {
      await bureaucrat.requestTrial(
        values.preferredReseller,
        values.emailOptIn,
      );
      onComplete();
    } catch (err) {
      scroll.scrollToTop();

      if (trialErrors[err.body?.code]) {
        setAlert(trialErrors[err.body.code]);
        setShowAlert(true);
      } else {
        parseErrorMessage(err, setErrorMsg, history);
      }

      actions.setSubmitting(false);
    } finally {
      setShowProgress(false);
    }
  };

  return {
    handleSubmit,
    handleCancel,
    errorMsg,
    showProgress,
    showAlert,
    setShowAlert,
    alert,
  };
};
